export default "__VITE_ASSET__DebrQHjP__"